export default (map, method) => map.filterNot(method);
